export const DB_NAME = 'xcarol';
export const DB_SCHEMA_TABLE = '_schema';

export const DB_COMMON_CACHE_TABLE = '_commonCache';
export const DB_DELAYED_REQUEST_TABLE = '_delayedRequest';
export const DB_WYSIWYG_DATA_TABLE = '_wysiwygData';

/**
 * Any change in db schema - be it data or keys - must also increase this version, which atm deletes whole db and forces total refresh
 */
export const DB_VERSION = 8;

export interface DbSchemaTable {
    name: string;
    value: string | null;
    userId: string;
}
